import axios from "services/axios";

export function getInvoiceList(params = {}) {
	return axios.get("/v2/transaction/invoice-list", {params}).then(res => res.data);
}

export function getInvoiceDetail(id) {
	return axios.get(`/v2/transaction/invoice/${id}`).then(res => res.data);
}

export function updateInvoice(id, payload) {
	return axios.put(`/v2/transaction/invoice/${id}`, payload).then(res => res.data);
}

export function getCustomPaymentMethodOptions(params = {}) {
	return axios
		.get("/v2/payment-methods", {
			params: {
				provider: "custom",
				...params,
			},
		})
		.then(res => res.data);
}

export function getAdminPriceOptions(params = {}) {
	return axios
		.get("/admin_price", {
			params,
		})
		.then(res => res.data);
}

export function getDoctorOptions(params = {}) {
	return axios
		.get("/staff/full", {
			params: {
				roleId: 2,
				...params,
			},
		})
		.then(res => res.data);
}

export function getMedicineOptions(params = {}) {
	return axios
		.get("/medicine", {
			params: {
				sortBy: "id.desc",
				...params,
			},
		})
		.then(res => res.data);
}

export function getMedicineUnitOptions(params = {}) {
	return axios
		.get("/v2/transaction/list-medicine-units", {
			params,
		})
		.then(res => res.data);
}

export function getMedicinePreparationOptions(params = {}) {
	return axios
		.get("/v2/transaction/list-medicine-preparations", {
			params,
		})
		.then(res => res.data);
}

export function getMedicineDetail(id) {
	return axios.get(`/medicine/${id}`).then(res => res.data);
}
